import React, { Component, Fragment } from 'react'
import AudioComponent from '../AudioComponent'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import { withRouter } from 'react-router-dom'
import { pages } from '../../utils/constants'
import InfoListContent from './InfoListContent'
import SimpleTextContent from './SimpleTextContent'
import Loader from '../Loader'
import ServiceDetailTitle from './ServiceDetailTitle'
import TextDescription from '../TextDescription'
import MosaicText from '../MosaicText'
import AudioVideoContent from './AudioVideoContent'
import AdditionalServices from './AdditionalServices'
import './index.sass'
import '../Services/Service/index.sass'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

class ServiceDetails extends Component {
  state = {
    service: this.props.match.params.service,
    typeService: this.props.match.params.typeService,
  }

  componentDidMount = () => {
    const {
      serviceDetails,
      actions: { getServiceDetails },
    } = this.props
    const { typeService } = this.state
    if (!serviceDetails[typeService]) {
      getServiceDetails(typeService)
    }
  }

  componentWillUnmount = () => {
    const {
      actions: { setPlayingStatus, toggleVisibleAudioPlayer },
    } = this.props
    setPlayingStatus(false)
    toggleVisibleAudioPlayer(false)
  }

  componentDidUpdate = () => {
    const { typeService } = this.state
    const newTypeService = this.props.match.params.typeService
    const {
      serviceDetails,
      actions: { getServiceDetails },
    } = this.props
    if (serviceDetails) {
      this.setAudioList()
    }
    if (typeService !== newTypeService) {
      if (!serviceDetails[newTypeService]) {
        getServiceDetails(newTypeService)
      }

      this.setState({
        typeService: newTypeService,
      })
    }
  }

  handleBack = () => {
    const { lng, history } = this.props
    const path = lng === 'en' ? `/${pages.SERVICES}` : `/${lng}/${pages.SERVICES}`
    history.push(path)
  }

  setAudioList = () => {
    const { typeService } = this.state
    const {
      serviceDetails,
      actions: { setPlayList },
    } = this.props
    const serviceData = serviceDetails[typeService]
    if (!serviceData) return
    let audioList = []
    if (serviceData.audio1) {
      audioList = [...audioList, ...serviceData.audio1.audioList]
    }
    if (serviceData.audio2) {
      audioList = [...audioList, ...serviceData.audio2.audioList]
    }
    audioList.length > 0 && setPlayList(audioList)
  }

  

  render = () => {
    const { service, typeService } = this.state
    const { loading, t, lng, isAudioVisible, serviceDetails } = this.props
    const serviceData = serviceDetails[typeService]
    const translatedMainText =
      serviceData && serviceData.mainText.map(text => t(`serviceDetails.${text}`))
    return (
      <Fragment>
        <Helmet>
          <html lang={lng} />
          <title>{t(`meta.serviceDescr.${typeService}.title`)}</title>
          <link rel="alternate" hrefLang="en"
              href={`https://unimedia.io/services/${service}/${typeService}`} />
          <link rel="alternate" hrefLang="de"
              href={`https://unimedia.io/de/services/${service}/${typeService}`} />
          <link rel="alternate" hrefLang="ru"
              href={`https://unimedia.io/ru/services/${service}/${typeService}`} />
          <link rel="alternate" hrefLang="x-default"
              href={`https://unimedia.io/services/${service}/${typeService}`} />
          <meta name="description" content={t(`meta.serviceDescr.${typeService}.descr`)} />
          {lng === 'en' ? <link rel="canonical" href={`https://unimedia.io/services/${service}/${typeService}`} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/services/${service}/${typeService}`} />}
          {lng === 'en' && <meta name="keywords" content={t(`meta.serviceDescr.${typeService}.keywords`)} />}
          <meta property="og:title" content={t(`meta.serviceDescr.${typeService}.title`)} />
          <meta property="og:description" content={t(`meta.serviceDescr.${typeService}.descr`)} />
          <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
          <meta property="og:url" content={lng === 'en' ? `https://unimedia.io/services/${service}/${typeService}`: `https://unimedia.io/${lng}/services/${service}/${typeService}`} />
          <script type="application/ld+json">
          {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t(`meta.serviceDescr.${typeService}.descr`)}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "offers": {
                "@type": "AggregateOffer",
                "url": "",
                "priceCurrency": "USD",
                "lowPrice": "80",
                "offerCount": "156"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.services')}",
                "item": "https://unimedia.io/services"
              },{
                "@type": "ListItem",
                "position": 3,
                "name": "${t(`services.${service}`)}",
                "item": "https://unimedia.io/services/${service}"
              },{
                "@type": "ListItem",
                "position": 4,
                "name": "${t(`services.${typeService}`)}"
              }]
            }]`}
          </script>
        </Helmet>
        <ScrollUpButton id={'serviceDetails'} />
        <div className="service-details-page container overflow-y" id={'serviceDetails'}>
          <ServiceDetailTitle serviceDetail={typeService} title={service} />
          <div className="container-wrapper">
          <Breadcrumbs pathname={window.location.pathname}/>
            {/* <button onClick={this.handleBack} className="btn btn-back subtitle-2">
              {t('general.back')}
            </button> */}
            {loading || !serviceData ? (
              <Loader />
            ) : (
              <Fragment>
                <h3>{lng === 'en'? t(`services.${typeService}-title`) : t(`services.${typeService}`)}</h3>
                <TextDescription arrText={translatedMainText} />

                <AudioVideoContent video={serviceData.video1} audio={serviceData.audio1} />

                <MosaicText arrText={serviceData.mosaicText} />

                <AudioVideoContent video={serviceData.video2} audio={serviceData.audio2} />

                <SimpleTextContent arrText={serviceData.simpleText1} />

                <InfoListContent arrText={serviceData.infoList.text} />

                <AudioVideoContent video={serviceData.video3} audio={serviceData.audio3} />

                <SimpleTextContent arrText={serviceData.simpleText2} />

                <AdditionalServices additionalServices={serviceData.additionalServices} />
              </Fragment>
            )}
            {isAudioVisible && <AudioComponent />}
          </div>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  loading: state.app.loading,
  isAudioVisible: state.audioPlayer.isVisible,
  serviceDetails: state.serviceDetails,
})

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(ServiceDetails))
)
